import { render, staticRenderFns } from "./BottomSortDialog.vue?vue&type=template&id=bd72337e&scoped=true"
import script from "./BottomSortDialog.vue?vue&type=script&lang=ts"
export * from "./BottomSortDialog.vue?vue&type=script&lang=ts"
import style0 from "./BottomSortDialog.vue?vue&type=style&index=0&id=bd72337e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd72337e",
  null
  
)

export default component.exports